/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { getProjectKeyId } from '@jira/router-resources__utils/src/getProjectKeyId.tsx';

import {
	// eslint-disable-next-line jira/restricted/@atlassian/react-resource-router
	createResource,
	type Match,
	type Query,
	type RouteResource,
} from '@atlassian/react-resource-router';
import { fetchJsmReportsSidebarNavInfo } from '../../../services/sidebar/jsm-reports-sidebar-navigation/main.tsx';
import type { JiraServiceManagementNavReportsData } from '../../../services/sidebar/jsm-reports-sidebar-navigation/types.tsx';

const getIdentifier = (match: Match, query: Query): string => {
	const { projectKey, projectId } = getProjectKeyId(match, query);
	return projectKey || projectId;
};

export const staticSidebarJsmReportsResource: RouteResource<JiraServiceManagementNavReportsData | null> =
	createResource<JiraServiceManagementNavReportsData | null>({
		type: 'NAVIGATION_SIDEBAR_JIRA_SERVICE_MANAGEMENT_REPORTS',
		getKey: ({ match, query }) => getIdentifier(match, query) ?? 'none',
		getData: async ({ match, query }) => {
			const projectKeyOrId = getIdentifier(match, query);
			if (projectKeyOrId == null) {
				return null;
			}
			return fetchJsmReportsSidebarNavInfo(projectKeyOrId);
		},
		maxAge: 5 * 60 * 1000,
	});
